var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-export"},[_c('button',{staticClass:"btn",attrs:{"type":"button"}},[_c('IconExport',{attrs:{"width":"25px","height":"25px"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }